import { ArticleBuilder } from '../../models/builders/article.builder';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { OperationProcessBuilder } from '../../models/builders/operation-process.builder';

@Injectable()
export class ArticleApiService {

  private apiUrl: string;

  constructor(private httpClient: HttpClient) {
    this.apiUrl = `${ environment.apiUrl }articles`;
  }

  getArticles() {
    return this.httpClient.get(`${ this.apiUrl }`)
      .pipe(
        map(ArticleBuilder.fromList)
      );
  }

  getOperationProcessesByArticle(hash: any) {
    return this.httpClient.get(`${ this.apiUrl }/${ hash }/operation-processes`)
      .pipe(
        map(OperationProcessBuilder.fromListByCode)
      );
  }

  searchArticles(chain: string) {
    const params = new HttpParams().append('search', chain);
    return this.httpClient.get(`${this.apiUrl}/search`, { params })
      .pipe(
        map(ArticleBuilder.fromList)
      );
  }

  getArticleByHash(hash: string) {
    return this.httpClient.get(`${this.apiUrl}/${ hash }`)
      .pipe(
        map(ArticleBuilder.fromJson)
      );
  }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/services/api/article-api.service.ts